import React, { FC, useEffect } from 'react';
import { errorModalViewStore } from 'src/store/modal';
import { initActiveMenu, setMenuObj } from 'src/utils/menuSet';
import Template from './template';

interface Props {}
const Login: FC<Props> = () => {
  // Fetch Data
  // const setModalState = errorModalViewStore(state => state.set);
  // const setMenu = menuStore(state => state.bind);
  // const { data, isLoading, error, menuSet } = fetchMenu();

  // useEffect(() => {
  //   if (error.type === 'error') {
  //     setModalState({ data: error, active: '_active' });
  //   }
  //   const { menuData, chekedMenu } = setMenuObj(menuSet.id, data);
  //   setMenu({ data: menuData, checked: chekedMenu });
  // }, [data]);
  // useEffect(() => {
  //   hideChat();
  // }, []);

  return <Template />;
};

export default Login;
